<template>
    <div class="sc04">
        <h3><span class="tit-st"><b>지표</b>로 보는</span> 데이터 강남</h3>
        <a :href="$_WC.cp + 'indicator'" class="btn-more">더보기</a>

        <!-- <div class="sc04_01">
            <h4>분야별 지표</h4>
            <div class="sc04_icon">
                <a v-for="(cate, index) in indicatorCateList"
                    :class="[iconMap[cate.commonCode], cate.commonCode === selectedIndicatorCate ? 'on' : '']"
                    href="javascript: void(0);" @click.prevent="selectIndicatorHref(cate.commonCode)">
                    <span>{{ cate.localeTitle }}</span>
                </a>
            </div>
        </div> -->

        <div class="sc04_02">
            <!-- <h4>최신 업데이트</h4> -->
            <div class="sc04_02_area">
            <span v-for="(list, index) in lastestIdxMap">
                <IndicatorBox
                    v-for="indicator in list"
                    :key="indicator.idxSqno"
                    :box-info="indicator"
                    :area-no="1"
                    :box-clazz="boxClzz"
                    :indicator-data-map="indicatorDataMap"
                    :indicator-data-kd-hdng-map="indicatorDataKdHdngMap"
                    :is-main="true"/>
            </span>
            </div>
        </div>

    </div>
</template>

<script>
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import {mapGetters} from "vuex";

import IndicatorBox from '@/views/indicator/IndicatorBox.vue';

export default {
    name: 'Indicator',
    data() {
        return {
            indiSwiper: undefined,
            boxClzz: 'sc04_02_box',
        }
    },
    components: {
        IndicatorBox,
    },
    created(){
    },
    computed: {
        ...mapGetters({
            iconMap: 'getIconMap',
            indicatorCateList: 'getIndicatorCateList',
            indicatorLatestedIdxList: 'getIndicatorLatestedIdxList',
            indicatorLatestedDataKdMap: 'getIndicatorLatestedDataKdMap',
            indicatorLatestedDataMap: 'getIndicatorLatestedDataMap',
            indicatorLatestedDataKdHdngMap: 'getIndicatorLatestedDataKdHdngMap',
            selectedIndicatorCate: 'getSelectedIndicatorCate',

            selectedIndicatorList : 'getSelectedIndicatorList',

            indicatorIdxList : 'getIndicatorIdxList',
            indicatorDataMap: 'getIndicatorDataMap',
            indicatorDataKdHdngMap: 'getIndicatorDataKdHdngMap',
        }),
        lastestIdxMap() {
            let map = {};
            // 최신 업데이트 지표 표출
            // if(this.indicatorIdxList.length > 0) {
            //     let idxList = this.indicatorIdxList.sort((p, c) => {
            //         if(p.basdtVal === null){
            //             p.basdtVal = '';
            //         }
            //         if(c.basdtVal === null){
            //             c.basdtVal = '';
            //         }
            //         let pp = p.basdtVal.padEnd(14, '0');
            //         let cc = c.basdtVal.padEnd(14, '0');
            //         return Number(cc) - Number(pp);
            //     });
            //     let pageIdx = 0;
            //     let maxLength = 6;
            //     idxList.forEach((d, index) => {
            //         if (index < maxLength) {
            //             if (typeof map[pageIdx] === $_TYPE.UNDEF) {
            //                 map[pageIdx] = [];
            //             }
            //             map[pageIdx].push(d);
            //             if (index % maxLength === 5) {
            //                 pageIdx++;
            //             }
            //         }
            //     });
            // }
            
            // 지표 항목당 1개씩 표출 - 교통안전:6, 행정:1, 보건4:, 교육5, 복지3, 경제2
            if(this.indicatorIdxList.length > 0) {
                let idxMap = {};
                this.indicatorIdxList.forEach(d => {
                    if(typeof idxMap[d.idxCateCd] === 'undefined') {
                        idxMap[d.idxCateCd] = [];
                    }
                    idxMap[d.idxCateCd].push(d);
                });
                // console.log('idxMap', idxMap);
                for(let key in idxMap) {
                    // 1-1 각 지표분류별 최신 기준일 표출
                    // idxMap[key].sort((p, c) => {
                    //     if(p.basdtVal === null){
                    //         p.basdtVal = '';
                    //     }
                    //     if(c.basdtVal === null){
                    //         c.basdtVal = '';
                    //     }
                    //     let pp = p.basdtVal.padEnd(14, '0');
                    //     let cc = c.basdtVal.padEnd(14, '0');
                    //     return Number(cc) - Number(pp);
                    // });

                    // 1-2 각 지표분류별 지표순서 첫번째 항목 표출
                    idxMap[key].sort((p, c) => {
                        return Number(p.idxDispSq) > Number(c.idxDispSq) ? 1 : Number(p.idxDispSq) < Number(c.idxDispSq) ? -1 : 0;
                    });

                    if(typeof map[0] === 'undefined') {
                        map[0] = [];
                    }
                    if(key < 7) {
                        map[0].push(idxMap[key][0]);
                    }
                }
                // console.log('idxMap', idxMap);
                // let pageIdx = 0;
                // let maxLength = 6;
                // idxList.forEach((d, index) => {
                //     if (index < maxLength) {
                //         if (typeof map[pageIdx] === $_TYPE.UNDEF) {
                //             map[pageIdx] = [];
                //         }
                //         map[pageIdx].push(d);
                //         if (index % maxLength === 5) {
                //             pageIdx++;
                //         }
                //     }
                // });
            }
            // console.log('map', map);
            return map;
        },
    },
    methods: {
        selectIndicatorHref(code){
            location.href = $_WC.cp + 'indicator?cate='+code;
        },
    },
};
</script>
<style>
.swiper-wrapper {
    display: flex !important;
}
.sc04_02_box .mainP {color:#ff4ed3 !important;}
/* .sc04_02_box .mainY {color:#d3cf00 !important;} */
</style>
